import { render, staticRenderFns } from "./PrivateArea.vue?vue&type=template&id=06b38620&"
import script from "./PrivateArea.vue?vue&type=script&lang=js&"
export * from "./PrivateArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports